
import { Link } from 'react-router-dom';
import { trackPhoneClick, trackLineClick } from '../../utils/tracking';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const businessInfo = {
    name: '建鈞精緻搬家',
    phone: '0978-900-081',
    email: 'sadiest018moving@gmail.com',
    address: '新北市泰山區福德街49號3樓',
    plusCode: '3C7J+FW 山腳里',
    hours: '週一至週日 8:00-20:00',
    line: 'https://line.me/ti/p/@285yavdh',
    facebook: 'https://www.facebook.com/profile.php?id=61584784501385&locale=zh_TW',
    googleMaps: 'https://www.google.com/maps/search/建鈞精緻搬家+新北市泰山區福德街49號3樓'
  };

  const quickLinks = [
    { to: '/', label: '首頁', icon: 'ri-home-line' },
    { to: '/about', label: '關於我們', icon: 'ri-information-line' },
    { to: '/services', label: '服務項目', icon: 'ri-service-line' },
    { to: '/pricing', label: '收費標準', icon: 'ri-price-tag-3-line' },
    { to: '/cases', label: '成功案例', icon: 'ri-gallery-line' },
    { to: '/faq', label: '常見問題', icon: 'ri-question-line' },
  ];

  const serviceAreas = [
    { to: '/area/new-taipei', label: '新北市搬家' },
    { to: '/area/taipei', label: '台北市搬家' },
    { to: '/area/taoyuan', label: '桃園市搬家' },
    { to: '/area/hsinchu', label: '新竹市搬家' },
  ];

  const serviceTypes = [
    { label: '套房搬家', icon: 'ri-home-4-line' },
    { label: '辦公室搬遷', icon: 'ri-building-line' },
    { label: '廢棄物清運', icon: 'ri-delete-bin-line' },
    { label: '人力搬工', icon: 'ri-team-line' },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* 頂部 CTA 區域 */}
      <div className="border-b border-gray-700/50">
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold mb-2">準備開始您的搬家計畫？</h3>
              <p className="text-gray-400">立即聯絡我們，獲取免費專業評估與報價</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={businessInfo.line}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackLineClick('footer-cta')}
                className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
              >
                <img 
                  src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                  alt="LINE" 
                  className="w-5 h-5"
                />
                LINE 免費諮詢
              </a>
              <a
                href={`tel:${businessInfo.phone.replace(/-/g, '')}`}
                onClick={() => trackPhoneClick(businessInfo.phone)}
                className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-full font-semibold transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-lg"></i>
                {businessInfo.phone}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* 主要內容區域 */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* 公司資訊 */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/e5fea51548a5e186b09c2cfef32a0653.jpeg"
                alt="建鈞精緻搬家 Logo"
                className="w-12 h-12 object-contain rounded-xl"
              />
              <div>
                <h3 className="text-xl font-bold">{businessInfo.name}</h3>
                <p className="text-sm text-gray-400">專業搬家服務</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6 text-sm">
              深耕北台灣超過10年，提供新北、台北、桃園、新竹地區優質搬家服務。專業團隊、透明報價、全程保險，是您最值得信賴的搬家夥伴。
            </p>
            
            {/* 社群連結 */}
            <div className="flex gap-3">
              <a
                href={businessInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-teal-600 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href={businessInfo.line}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-green-600 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                aria-label="LINE"
              >
                <i className="ri-line-fill text-xl"></i>
              </a>
              <a
                href={businessInfo.googleMaps}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-red-500 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                aria-label="Google 地圖"
              >
                <i className="ri-map-pin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* 快速連結 */}
          <div>
            <h4 className="text-lg font-bold mb-6 flex items-center gap-2">
              <i className="ri-links-line text-teal-400"></i>
              快速連結
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.to} 
                    className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center gap-2 group text-sm"
                  >
                    <i className={`${link.icon} text-teal-500 group-hover:translate-x-1 transition-transform duration-300`}></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 服務區域 */}
          <div>
            <h4 className="text-lg font-bold mb-6 flex items-center gap-2">
              <i className="ri-map-2-line text-teal-400"></i>
              服務區域
            </h4>
            <ul className="space-y-3 mb-6">
              {serviceAreas.map((area, index) => (
                <li key={index}>
                  <Link 
                    to={area.to} 
                    className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center gap-2 group text-sm"
                  >
                    <i className="ri-map-pin-line text-teal-500 group-hover:scale-110 transition-transform duration-300"></i>
                    {area.label}
                  </Link>
                </li>
              ))}
            </ul>
            
            <h4 className="text-lg font-bold mb-4 flex items-center gap-2">
              <i className="ri-service-line text-teal-400"></i>
              服務項目
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {serviceTypes.map((service, index) => (
                <div key={index} className="flex items-center gap-2 text-gray-400 text-sm">
                  <i className={`${service.icon} text-teal-500`}></i>
                  <span>{service.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 聯絡資訊 */}
          <div>
            <h4 className="text-lg font-bold mb-6 flex items-center gap-2">
              <i className="ri-customer-service-2-line text-teal-400"></i>
              聯絡我們
            </h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`tel:${businessInfo.phone.replace(/-/g, '')}`}
                  className="flex items-start gap-3 group"
                  onClick={() => trackPhoneClick(businessInfo.phone)}
                >
                  <div className="w-10 h-10 bg-teal-600/20 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors">
                    <i className="ri-phone-line text-teal-400 group-hover:text-white transition-colors"></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 mb-0.5">24小時服務專線</div>
                    <div className="font-semibold text-white group-hover:text-teal-400 transition-colors">{businessInfo.phone}</div>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="flex items-start gap-3 group"
                >
                  <div className="w-10 h-10 bg-teal-600/20 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors">
                    <i className="ri-mail-line text-teal-400 group-hover:text-white transition-colors"></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 mb-0.5">電子郵件</div>
                    <div className="font-semibold text-white group-hover:text-teal-400 transition-colors text-sm break-all">{businessInfo.email}</div>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href={businessInfo.googleMaps}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 group"
                >
                  <div className="w-10 h-10 bg-teal-600/20 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors">
                    <i className="ri-map-pin-line text-teal-400 group-hover:text-white transition-colors"></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500 mb-0.5">公司地址</div>
                    <div className="font-semibold text-white group-hover:text-teal-400 transition-colors text-sm">{businessInfo.address}</div>
                  </div>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 bg-teal-600/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-teal-400"></i>
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-0.5">服務時間</div>
                  <div className="font-semibold text-white text-sm">{businessInfo.hours}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* 底部版權區域 */}
      <div className="border-t border-gray-700/50">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/price-comparison" className="text-gray-500 hover:text-teal-400 transition-colors text-sm">
                價格比較
              </Link>
              <Link to="/calculator" className="text-gray-500 hover:text-teal-400 transition-colors text-sm">
                費用試算
              </Link>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors text-sm cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
